// extracted by mini-css-extract-plugin
export default {"root":"notFound-module--root--YyW6K","header":"notFound-module--header--EXdN4","button":"notFound-module--button--Q4yuO","desc":"notFound-module--desc--kug2A"};